import React from 'react'
import { ReactElement, ReactNode } from 'react'

export const convertChildrenToElementsArray = (children: ReactNode): ReactElement[] => {
    return (
        React.Children.map(children, (child) => {
            const isValidElement = React.isValidElement(child)
            if (!isValidElement) return null

            const isFragment = isValidElement && child.type === React.Fragment

            return isFragment ? child.props.children : child
        })?.filter((child) => child !== null) ?? []
    )
}
